import { render, staticRenderFns } from "./advertoauth.vue?vue&type=template&id=01c1d470&"
import script from "./advertoauth.vue?vue&type=script&lang=js&"
export * from "./advertoauth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports